import * as React from "react";
import getConfig from "next/config";
import { GoogleAnalytics } from "@grandvisionhq/analytics";
import { monetate } from "@grandvisionhq/svc-monetate";
import { g as gtmConfig } from "./google-tag-manager.js";
const { publicRuntimeConfig } = getConfig();
const selfUrl = publicRuntimeConfig.selfUrl || "";
const useCheckoutEventManager = ({ pageType, pageHref }) => {
  React.useEffect(() => {
    if ("browser" in process) {
      const GAId = gtmConfig.ids?.[0];
      if (window && !window["GA_INITIALIZED"] && GAId) {
        GoogleAnalytics.initGA(GAId, { debug: true });
        window["GA_INITIALIZED"] = true;
      }
    }
    GoogleAnalytics.logPageView(`${selfUrl}/${pageHref}`);
    monetate().commitMonetateEvent(pageType);
  }, []);
};
export {
  useCheckoutEventManager as u
};
//# sourceMappingURL=use-checkout-event-manager.js.map
